<template>
  <modal
    class="history-order-popup"
    :visible="$f.orderOpened"
    @on-close="$f.hideOldOrderPopup()"
  >
    <order-card
      :order-number="$f.currentOrderNumber"
      @on-close="toOrders"
      is-last
      show-support-info
      is-expanded-default
    />
  </modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import OrderCard from '@/components/account/order-card/order-card.vue';

export default {
  name: 'order-popup',

  components: {
    OrderCard,
  },

  props: {
    redirectToOrders: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    ...mapGetters({
      ORDERS: 'orders/orders',
      PROGRESS: 'orders/loadProgress',
      END: 'orders/end',
    }),
  },

  methods: {
    ...mapActions({
      LOAD_ORDERS: 'orders/loadOrders'
    }),

    toOrders() {
      if (this.redirectToOrders) {
        location.assign('/account/orders');
        return;
      }
      this.$f.hideOldOrderPopup();
    },
  }
}
</script>

<style lang="scss">
.history-order-popup {
  & > .modal-content {
    width: 100%;
    height: 100vh;
    min-height: 100%;
    padding: 44px 16px 64px;
    border-radius: 0;

    & > .close-button {
      color: $gray;
    }
  }
}

@include breakpoint("tablet") {
  .history-order-popup {
    & > .modal-content {
      padding: 56px 32px 80px;
    }
  }
}

@include breakpoint("desktop") {
  .history-order-popup {
    & > .modal-content {
      & > .close-button {
        width: 80px;
        height: 80px;
        padding: 24px;

        svg {
          width: 32px;
          height: 32px;
        }
      }
    }
  }
}
</style>
